import { ChangeDetectionStrategy, Component, ChangeDetectorRef,OnInit, ViewEncapsulation, ElementRef, AfterViewInit, ViewChild, OnChanges, SimpleChanges } from '@angular/core';
import { OneBreadcrumb } from '@one/angular-kit/navigation';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { QnSbnService } from '../../services/qn-sbn-service.service';
import { HttpResponse, HttpErrorResponse } from '@angular/common/http';
import { OneSnackBarService, OneSnackBarType } from '@one/angular-kit/modal';
import { AppUtils } from 'projects/dialog/src/app/shared/utilities/app-utils';
import { MatDialog } from '@angular/material/dialog';
import { QnSbnDataService } from '../../services/qn-sbn-data-service.service';
import { NotificationAuditTrailComponent } from '../notification-audit-trail/notification-audit-trail.component';

@Component({
  selector: 'dl-account-details',
  templateUrl: './account-details.component.html',
  styleUrls: ['./account-details.component.scss'],
  encapsulation: ViewEncapsulation.None,
  changeDetection: ChangeDetectionStrategy.OnPush
})

export class AccountDetailsComponent implements OnInit {

  public breadcrumbs: OneBreadcrumb[];
  public customerDataObj: any;
  public Status:any;
  public CustomerId: any;
  public customerTitle: any;
  public showEditControls: boolean = false;
  public customerData:any;
  public customerNotificationData: any;
  public CustomerDetails:any;
  public NotificationId:any;
  public userFileSize = { size: 0, type: '' };
  public userPermission: any;
  public isSetCom: boolean = false;
  public isNotiStat: boolean =false;
  public title: string = '';
  public accFormGroup: FormGroup;
  public accountDetails:any;
  public accountDataObj: any;
  public auditTrailDatafromAPI: any;
  public accountNotificationId:any;
  public accountFeedbackSubmissionDetails:any;
  public notificationCustomerDetails: any;
  public isEditDisabled: boolean=false;
  public internalNoteDetails: any;
  public contactNotification: any;

  constructor(
    public appUtils: AppUtils,
    private fb: FormBuilder,
    private _cdr: ChangeDetectorRef,
    private qnsbnservice :QnSbnService,
    public _QnSbnService:QnSbnService,
    public _QnSbnDataService:QnSbnDataService,
    public appUtil: AppUtils, 
    private router: Router,
    private readonly oneSnackBar: OneSnackBarService,
    private readonly dialog: MatDialog,
  ){}
  
  public ngOnInit(): void {
    console.log('%c AccountDetailsComponent ngOnInit', 'color: blue; font-weight: bold;');
    this.userPermission = this.qnsbnservice.getUserData();
    this.customerDataObj = history.state;
    this.customerData = this.customerDataObj.customerDetails.customerData;
    this.accountDataObj = this.customerData
    this.isSetCom = this.customerDataObj.customerDetails.isSetCom;
    this.isNotiStat = this.customerDataObj.customerDetails.notificationStatus;
    this.customerNotificationData = this.customerDataObj.customerDetails.notificationData;
    this.NotificationId = this.customerData.NotificationId;
    this.CustomerId = this.customerData.CustomerId;
    this.customerTitle = this.customerData.AccountName + " " + this.customerData.AccountId
    this.title = this.customerDataObj.customerDetails.notificationData.Title;
    this.contactNotification = this.customerDataObj.notificationDataObj.contactData;

    this.breadcrumbs = [
      {
        label: 'Notifications'
      },
      {
        label: this.customerNotificationData.LocalId
      },
      {
        label: this.customerData.AccountName + " " + this.customerData.AccountId
      }
    ];
    
    if (this.customerData.AccountStatus === "Feedback Received") {
      this.isEditDisabled = true;
    }
   
    this.accFormGroup = this.fb.group({
      formAccName: [null, [Validators.required]],
      formAccID: [null, [Validators.required]],
      formNote: [null]
    });
    
    
    let data=this.customerDataObj.notificationDataObj.contactData.filter(contact=>
      contact.hasOwnProperty('CustomerAddedFirstName')&&
      contact.hasOwnProperty('CustomerAddedLastName')&&
      contact.hasOwnProperty('CustomerAddedEmail')&&
      contact.hasOwnProperty('CustomerAddedCountry')&&
      contact.IsNonDialogUser==='TRUE'
      // &&      contact.Type==='SBN'
    )

    if(data.length==1){
      this.accountFeedbackSubmissionDetails=data[0];
    }
    else if(data.length>1){
      let main=data[0];

      for(let i=1;i<data.length;i++){
      
        if(main.AccountFeedbackReceived<data[i].AccountFeedbackReceived){
          main=data[i];
        }
      }
      this.accountFeedbackSubmissionDetails=main;
    }
    else{
      this.accountFeedbackSubmissionDetails=[]
    }
  
  }


  openEditForm() {
    this.showEditControls = true;
    this.accFormGroup.controls['formAccID'].setValue(this.customerData.AccountId);
    this.accFormGroup.controls['formAccName'].setValue(this.customerData.AccountName);
    this.accFormGroup.controls['formNote'].setValue(this.customerData.NoteText);
  }

  editFormDetails() {
    let internalText =  this.accFormGroup.value.formNote;
    if(internalText.length > 500){
       this.oneSnackBar.open('Note is too long. Maximum length is 500 characters.', OneSnackBarType.ERROR, '', { duration: 5000 });
    }else{
    this.accountDetails = {
      body:{
        "NewId": this.accFormGroup.value.formAccID,
        "NewName": this.accFormGroup.value.formAccName,
        "AccountNotificationId": this.customerData.AccountNotificationId
      }
    };
    const accountDetailsJson = JSON.stringify(this.accountDetails);
    this.qnsbnservice.EditAccountData(accountDetailsJson).subscribe(
      (response) => {
        if(response.statusCode === 200){
          this.customerData.AccountName = this.accFormGroup.value.formAccName;
          this.customerData.AccountId = this.accFormGroup.value.formAccID;
          this.closeEditForm();
          this._cdr.detectChanges();
          this.oneSnackBar.open('Account data updated Successfully', OneSnackBarType.SUCCESS, '', { duration: 5000 });
        }else{
          this.closeEditForm();
          this._cdr.detectChanges();
          this.oneSnackBar.open('Account ID or name already exists', OneSnackBarType.ERROR, '', { duration: 5000 });
        }
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Account data updation Failed.');
      }
    );

      this.internalNoteDetails = {
          "NoteType": "Account",
          "NoteText" : this.accFormGroup.value.formNote,
          "NotificationId": this.customerDataObj.customerDetails.notificationData.NotificationId || "",
          "AccountNotificationId": this.customerData.AccountNotificationId || "",
          "userId": this.customerDataObj.customerDetails.notificationData.UserId || "",
          "userRole":this.customerDataObj.customerDetails.notificationData.UserRole || ""
      }
        this.qnsbnservice.saveInternalNote(this.internalNoteDetails).subscribe(
        (response) => {
          if(response.$metadata?.httpStatusCode === 200){
             if(this.customerData?.NoteText !== this.accFormGroup.value.formNote){
                this.customerData.NoteDate = new Date();
              }
              this.customerData.NoteText = this.accFormGroup.value.formNote;
              this._cdr.detectChanges();
              this.closeEditForm();
          }else{
            this.closeEditForm();
            this._cdr.detectChanges();
          }
        },
        (error: HttpErrorResponse) => {
          this.qnsbnservice.httpErrorHandler(error, 'Note updation failed');
        }
      );
    }
  }

  closeEditForm() {
    this.showEditControls = false;
  }

  public bytesCalculation(bytes: number, decimals: number = 2): any {
    if (bytes === 0) {
      this.userFileSize.size = 0;
      this.userFileSize.type = '';
      return '0 Bytes';
    }
    const k = 1024;
    const dm = decimals <= 0 ? 0 : decimals;
    const sizes = ['Bytes', 'KB', 'MB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));

    this.userFileSize.size = 0;
    this.userFileSize.type = '';

    this.userFileSize.size = parseFloat((bytes / Math.pow(k, i)).toFixed(dm));
    this.userFileSize.type = sizes[i];
    return this.userFileSize;
  }

  public formatBytes(bytes: number, decimals: number = 2): string {
    this.bytesCalculation(bytes, decimals);
    return this.userFileSize.size + ' ' + this.userFileSize.type;
  }

  public displayStatus(status) {
    const statusText = status ? status : 'Pending';
    return statusText;
  }

  public downloadDocument(globalNotificationId: string, fileExtension: string) {
    this.qnsbnservice.downloadPiosDocumentApi(globalNotificationId, fileExtension);
  }
  
  public downloadAttachment(fileName: string, notificationId: string, accountNotificationId?: string, attachment?: string) {
    if(accountNotificationId && attachment){
      this.qnsbnservice.downloadLocalAttachmentApi(fileName, notificationId, accountNotificationId, attachment);
    }else{
       this.qnsbnservice.downloadLocalAttachmentApi(fileName, notificationId);
    }
   
  }
  
  gotoNotificationDetailsPage(){
    this.qnsbnservice.getNotificationContactDetails(this.NotificationId).subscribe(
      (data:any) => {
        this._QnSbnService.getAccountList(this.NotificationId).subscribe(
          res =>{
            this.router.navigateByUrl('/notification-details', { state: { notificationData: this.customerNotificationData, contactData: data, accountDataObj: res.body } });
          },
          (err: HttpErrorResponse) => {
            this._QnSbnService.httpErrorHandler(err, 'Could not fetch Account Data');
          }
        );
      },
      (error: HttpErrorResponse) => {
        this.qnsbnservice.httpErrorHandler(error, 'Could not fetch contact details.');
        this.router.navigateByUrl('/notification-details', { state: { notificationData: this.customerNotificationData, contactData: [], accountDataObj: [] } });
      }
    );
  }
  
  gotoNotificationPage(){
    this.router.navigateByUrl('/notification');
  }

  public viewAuditTrail(){

    this.accountNotificationId=this.customerData.AccountNotificationId;
    this.qnsbnservice.getAccountNotificationAuditTrailList(this.accountNotificationId).subscribe(
      res =>{
        this.auditTrailDatafromAPI=res;
        this.dialog.open(NotificationAuditTrailComponent,{
          data:{
            tableData: this.auditTrailDatafromAPI
          },
          disableClose: true,
          panelClass: 'AuditTrailPopUp'
        });
      },
      err =>{
        this.oneSnackBar.open('Failed to fetch Audit Trail Data', OneSnackBarType.ERROR, '', { duration: 5000 });
      }
    );
  }

  public isNoAttachmentsVisible(): boolean {
    const hasLocalAttachments = this.customerNotificationData?.NotificationAttachments && 
    this.customerNotificationData.NotificationAttachments.length > 0;
    
    const hasGlobalAttachments = this.customerNotificationData?.DocumentEnabled === true &&
    this.customerNotificationData?.NotificationDocuments &&
    this.customerNotificationData.NotificationDocuments.length > 0 &&
    this.customerNotificationData.NotificationDocuments[0]?.Title;
        
    return !hasLocalAttachments && !hasGlobalAttachments;
  }
}
